import React,{useContext} from 'react';
import { ProjectContext } from '../utils/projectContext.js';
const Breadcrumbs = ({ projectArr, projectNow, handleClickItem, closeProject }) => {
  const {showLeftArrow, setShowLeftArrow} = useContext(ProjectContext);
  const {setChangeName } = useContext(ProjectContext);
  const modifiedHandleClickItem = async (e, item) => {
    e.stopPropagation(); 
    await setChangeName(true);
    handleClickItem(e, item); 
  };
  const closeOne=(e, index, name) => {
    e.stopPropagation();
    let canvasArr = JSON.parse(localStorage.getItem('canvasArr'));
    if(canvasArr){
      let newCanvasArr = canvasArr.filter(item => item.name !== name);
      localStorage.setItem('canvasArr', JSON.stringify(newCanvasArr));
    }
    closeProject(e, index);
  }
  return (
    <div
      className="breadcrumbs"
      style={{
        transform: showLeftArrow === false ? 'translateX(-300px)' : 'none',
        transition: 'transform 0.3s',
      }}
    >
      {projectArr.map((item, index) => (
        <div
          key={index}
          className={item.name === projectNow.name ? 'item activeItem' : 'item'}
          onClick={(e) => modifiedHandleClickItem(e, item)}
        >
          {item.name}.json
          <span onClick={(e) => closeOne(e, index, item.name)}>X</span>
        </div>
      ))}
    </div>
  );
};

export default Breadcrumbs;
